'use strict';
/**
 * @description Determine if a response data object is serialized JSON
 * @returns Boolean - true if the object is serialized JSON, false otherwise
 */

function isSerialized (prospect) {
  if (typeof prospect === 'string') {
    try {
      JSON.parse(prospect);
      return true;
    } catch (err) {
      return false;
    }
  }
  return false;
}

export default isSerialized;